<template>
  <div class="mx-4 flex flex-1 flex-col gap-6 py-4 md:mx-6 md:gap-8 md:py-6">
    <slot />
  </div>
</template>
